// extracted by mini-css-extract-plugin
export default {"About":"About_About__OubuO","About__container":"About_About__container__TJ3YP","Anout__block":"About_Anout__block__Cv2f+"};